import {BasicSelect,MultiSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Loader from '../../../../shared/components/loader';
import CONSTANT from './../../../../shared/constants/constant';
import Util from './../../../../shared/util/util';
import CreateTripManagement from './../CreateTripManagement';
import TripMgmtFirstLastMiles from './TripMgmtFirstLastMiles';
import TripServices from './../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
import Treeselect from '@riophae/vue-treeselect';
import CloseTrip from './../CreateTripManagement/closeTrip';
import TripSheetPdf from '../TripSheetPdf'
import Printd from 'printd';
import VueElementLoading from 'vue-element-loading';
import TripShipment from '../CreateTripManagement/TripShipment';
import DatePicker from 'vue2-datepicker'
import startTrip from './../CreateTripManagement/startTrip';
import { Validator } from 'vee-validate';
import Multiselect from 'vue-multiselect'
import XLSX from 'xlsx';
import iptracker from '../../../../../views/components/commonfunction/iptracker';
const moment = require('moment');
//test arc feature
export default {
  name: 'serviceareatemplate',
  components: {
    Validator,
    TripSheetPdf,
    startTrip,
    VueElementLoading,
    TripShipment,
    DatePicker,
    CryptoJS,
    Pagination,
    BasicSelect,
    Loader,
    CreateTripManagement,
    TripMgmtFirstLastMiles,
    CustomExpandableTable,
    TripServices,
    Treeselect,
    CloseTrip,
    iptracker,
    Multiselect
  },
  data: function() {
    return {
      loader:false,
      startTrips:false,
      tripid: '',
      tripStatus: null,
      assignedTo: '',
      podID:'',
      AWB: '',
      MPS: '',
      shortcuts:false,
      companyName: null,
      clientLocation: '',
      AssignedSR: null,
      tripCreationDate: '',
      tripStartDate: '',
      tripEndDate: '',
      tripStatuslist: [{'id':'created','label': 'Created'},{'id': 'start',"label":'Start'},{'id': 'completed',"label":'Completed'},{'id': 'closed',"label":'Closed'}],
      ClientLocationList: [],
      AssignedList: [],
      Assigneditem:{value:'',text:''},
      clientLocationitem:{value:'',text:''},
      isLoading:false,
      Loader:false,
      showCreateTrip:false,
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      offset:0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      tableColumn: ['Trip ID','Cargo TripID','Origin Branch', 'Trip Status', 'Assigned To','Assigned BA/ SR','Trip Created Date','Trip Tags','Action'],
      innerTableColumn: ['Assigned Zones'],
      tableItems: [],
      companyNamelist: [],
      selectedcompanyName: {
        "value": '',
        "text": ''
      },
      HubId:'',
      tripDetails:'',
      parentData: {},
      creationdateErr:'',
      viewTripMgmt:false,
      parenttripfm:'',
      parenttriplm:'',
      pickuprequestid:'',
      cargopod:'',
      TripType: '',
      awbdetails: '',
      mpsFM:'',
      mpsLM:'',
      expandableKey: 0,
      showGenerateTrip:false,
      tripSheet:{},
      tripsheetdata:'',
      showtripsheetpdf:false,
      showTripShipment:false,
      showDTHtostandered:false,
      dthId:"",
      tableArr:[],
      reason:"",
      userName:"",
      closeToolMessage:"",
      userdetail: {},
      showCloseTripModal:false,
      newObj:{
         awb:[],
         pickuparr:[],
      },
      disabledflag:false,
      FromDateErr:"",
      ToDateErr:""
    }
  },
  computed: {

  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userdetail = userdetail
    this.defaultHubID = userdetail.hubID[0];
    this.userName = userdetail.email;
    this.userrole = userdetail.rolename[0]
    await this.getSRListing();
    if( this.userrole == 'TSP BA Admin'){
      let results = this.AssignedList.filter(function (entry) { return entry.olddelveryuseroruserid == userdetail.vendorid; });
      this.AssignedSR = results[0].id
      this.disabledflag = true
    }
    this.getTripListing();
    this.getCompanyShortName();
  },
  methods: {
    closeTripModal(){
      this.showCloseTripModal = false
    },
    showcreatetrip(){
      this.parentData = {
        tripId: this.tripSheet.tripID,
        actionType: 'view'
      }
      this.showCreateTrip = true
      this.TripType = 'created'
    },
    showStartTrip(type){
      this.TripType = type
      if(this.tripStatus == "created"){
        this.parentData = {
          tripId: this.tripSheet.tripID,
          actionType: 'edit'
        }
        this.showCreateTrip = true
        this.TripType = 'created'
    }else{
      this.$alert("Trip Already Started", "", "success");
        this.showCreateTrip = false;
      }
  },
    async getTripSheetDetails(payload){
      let result = await TripServices.GetTripSheetDetails(payload)
      return result;
    },
    async ShowTripSheetPdf(){
      try {
        this.loader=true;
      this.showtripsheetpdf=false;
      let payload={
        tripid:this.tripSheet.tripID
      }
      let data = await this.getTripSheetDetails(payload)
      this.tripsheetdata={
        BranchName:data.data.data.BranchName,
        LmPending:data.data.data.LmPending,
        BranchCode:data.data.data.BranchCode,
        vehicleType:data.data.data.vehicletype,
        vehicleNumber:data.data.data.vehiclenumber,
        vehicleVendorName:data.data.data.vehiclevendorname,
        vehicleVendorType:data.data.data.vehiclevendortype,
        pickups:data.data.data.pickups,
        deliveries:data.data.data.deliveries,
        totalMpsFm:data.data.data.totalMpsFm,
        totalMpsLm:data.data.data.totalMpsLm,
        totalAwbPick:data.data.data.totalAwbToPick,
        totalAwbDeliver:data.data.data.totalAwbToDeliver,
        tripstartdate:data.data.data.tripstartdate,
        username:data.data.data.username,
        userid:data.data.data.userid,
        tripid:data.data.data.tripid,
        barcodevalue:data.data.data.tripid,
        startkm:data.data.data.startkm,
        endkm:data.data.data.endkm,
        FmTotalPhysicalWt:data.data.data.FmTotalPhysicalWt,
        LmTotalPhysicalWt:data.data.data.LmTotalPhysicalWt,
        destinationhubname: data.data.data.destinationhubname,
      }
      this.showtripsheetpdf=true;
      this.$nextTick(() => {
        this.downloadPDF();
      })
      this.loader=false;
      } catch (error) {
        console.log(error);
        this.loader=false;
      }
    },
    downloadPDF() {
      const d = new Printd();
      let cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
           }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:4px;
           }
           .vas{
            display:flex;
            flex-direction: column;
            border-bottom:none;
            border-left:none;
            border-right:none;
            padding-top:10px;
           }
           .apptDate{
             border: 1px solid black;
             font-size: 12px;
             border-radius: 10px;
             font-weight: bold;
             padding: 5px 1px;
             margin-bottom:10px;
           }
           .mall{
            border: 1px solid black;
            font-size: 12px;
            border-radius: 10px;
            font-weight: bold;
            padding: 5px 15px;
            margin-bottom:10px;
          }
           .style1{
            padding-bottom: 130px;
            padding-left:150px;
           }
           .style2{
            padding-left:180px;
           }
           .style7{
            width:40px;
           }
           .style3{
            padding-left:180px;
           }
           .style4{
            padding-left:-150px;
           }
           .style5{
            width: 8%;
           }
           .style6{
            width: 8%;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:30px !important;
           }
          }
          @media print {
          .pagebreak {
          page-break-after: always;
          }
          }
          @media print {
            body {
           margin-left: 0mm; margin-right: 0mm}
}
          `
      d.print(document.getElementById('printPDFData'), cssText);
      },
    showtripsheet(){
this.showGenerateTrip=true;
this.showTripShipment=true;
    },
    closeGenerateTripSheet(){
      this.showGenerateTrip = false;
      this.showTripShipment=false;
   },
    async getTripListing(){
      try {
        if(this.checkErr() == 1){
          return false
        }
        this.isLoading = true;
        this.tableItems = []
        if(this.$route.query.TripFilterData){
          this.tripStatus = this.$route.query.TripFilterData.tripStatus;
          let checkflag = this.$route.query.TripFilterData.todaydate;
           if(checkflag == 'true'){
          let currentdate = Util.getCurrentDate();
          this.tripStartDate = moment(currentdate).format('YYYY-MM-DD');
          this.tripEndDate = moment(currentdate).format('YYYY-MM-DD');
        }
        }
        let inputPayload = {
          "offset": this.offset,
          "limit": this.pageLimit,
          "hubid":this.defaultHubID, //for testing use 24
        }
        if(this.tripid){
          inputPayload.tripid = this.tripid.trim();
        }
        if(this.tripStatus){
          inputPayload.tripstatus = this.tripStatus;
        }
        if(this.AWB){
          inputPayload.awb = this.AWB.trim();
        }
        if(this.MPS){
          inputPayload.mps = this.MPS.trim();
        }
        if(this.companyName){
          inputPayload.clientid = this.companyName.id;
        }
        if(this.clientLocation){
          inputPayload.clientlocation = this.clientLocation;
        }
        if(this.AssignedSR){
          inputPayload.sruserid = this.AssignedSR;
        }
        if(this.tripCreationDate[0]){
          inputPayload.tripcreateddate = this.tripCreationDate;
        }
        if(this.tripStartDate){
          inputPayload.tripstartdate = this.tripStartDate;
        }
        if(this.tripEndDate){
          inputPayload.tripenddate = this.tripEndDate;
        }
        if(this.assignedTo){
          inputPayload.assigneduser = this.assignedTo;
        }

        let result = await TripServices.getTripList(inputPayload)
        if(result.data.code == 200){
          this.tableArr = result.data.data.rows;
          this.totalCount = result.data.data.count;
          this.tableItems = result.data.data.rows.map((el)=>{
            el.tripstatus=el.tripstatus=='created'?'Created':el.tripstatus=='start'?'Started':el.tripstatus=='completed'?'Completed':el.tripstatus=='closed'?'Closed':el.tripstatus
            let ispickupextended =0;
            if (el.helper) {
              ispickupextended = 2
              for (const property in el.helper) {
                if (el.helper[property].status == 1) {
                  ispickupextended = 1
                }
              }
            } 
            let triptag = [el.isdth, ispickupextended];
            return {
              'id': el.id,
              'Trip ID':el.tmstripid,
              'Cargo TripID': el.cargotripid,
              'Origin Branch':el.hubname,
              'Trip Status':el.tripstatus,
              // 'Client Short/ Display Name': '',
              'Assigned To': el.usertype,
              'Assigned BA/ SR': (el.username.charAt(el.username.length - 1) == ')') ? el.username : el.username +" " +'('+ el.userid + ')',
              'Trip Created Date': Util.displayDateTimeFormat(el.tripcreateddate),
              'Trip Tags': triptag,
              'Action': 'click OnEvent',
            }

          })

          this.expandableKey += 1
        }else{
          this.totalCount = 0
          this.tableItems = [];
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    checkErr() {
      let err = 0
      if ((this.tripStartDate != null && this.tripStartDate != "") && (this.tripEndDate != null && this.tripEndDate != "")) {
        this.FromDateErr = ""
        this.ToDateErr = ""
        err = 0
      }
      else {
        if (this.tripStartDate != null && this.tripStartDate != "") {
          this.ToDateErr = "Please Select End Date"
          this.FromDateErr = ""
          err = 1
        }
        else if (this.tripEndDate != null && this.tripEndDate != "") {
          this.FromDateErr = "Please Select Start Date"
          this.ToDateErr = ""
          err = 1
        }
        else {
          this.FromDateErr = ""
          this.ToDateErr = ""
        }
      }
      return err
    },
    async getCompanyShortName() {
      try {
        var CompanyShortList = [];
        let result = await TripServices.getActiveInactiveClientList()
        CompanyShortList = result.data.data;
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.companyNamelist.push({
            'id': CompanyShortList[i].ClientMasterID,
            'label': CompanyShortList[i].ClientShortName,
            'CompanyName': CompanyShortList[i].CompanyName
          })
        }
      } catch (err) {
        console.log(err);
      }
    },

    async getSRListing() {
      try {
        let InputPayload = {
          HubId: [this.defaultHubID]
        };
        let result = await TripServices.getSRList(InputPayload);
        let SRList = result.data.data;
        for (var i = 0; i < SRList.length; i++) {
          this.AssignedList.push({
            'id': SRList[i].userid,
            'label': SRList[i].srname + ' - '+ SRList[i].emptype +" " + '('+ SRList[i].userid + ')',
            'sremail': SRList[i].email,
            'olddelveryuseroruserid':SRList[i].olddelveryuseroruserid
          });
        }
      } catch (err) {
        console.log(err);
      }
    },

    selectedClientLocation(statusitem){

    },
    // selectedAssigned(statusitem){
    //   this.Assigneditem = statusitem
    //   this.AssignedSR = statusitem.value
    // },
    clearForm() {

    },
    showTripMgmt(type) {
      this.TripType = type
      this.showCreateTrip = true;
      if (type == 'created') {
        this.parentData = {}
      }
      let data = {
                    "projectname": this.userdetail.project,
                    "type": "web",
                    "userid": this.userdetail.userid,
                    "username": this.userdetail.username,
                    "routeurl":'/TripManagement',
                    "meta" : {
                      "event" : "apicall"
                    }
                  }
      let result = iptracker.getTraceIP(data);
      
    },
    async closeTrip(type){
      try {
        this.isLoading = true;
        let input = {
          tripid : this.tripSheet.tripID
        }
        let result = await TripServices.completeTripValidate(input);
        if(result.data.code == 200){
          this.TripType = type
          this.showCreateTrip = true;
        } else{
          this.newObj=result.data.data.data;
          this.showCloseTripModal=true;
        }
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    callParent() {
      this.showCreateTrip = false;
      this.TripType = ''
      this.parentData = {}
      this.tripStatus = null
      this.getTripListing();
    },

    searchTrip(){
      // if(!this.tripCreationDate){
      //   this.creationdateErr = 'Please Select Trip Creation Date'
      //   return false
      // }
      this.creationdateErr= ''
      this.currentPage = 1;
      this.offset = 0;
      this.getTripListing();
    },
    // selectCompanyName(data){
    //   this.companyName = data.text;
    // },

    resetBooking(){
      this.currentPage = 1;
      this.offset = 0;
      this.tripid = '';
      this.tripStatus = null;
      this.AWB = '';
      this.companyName = null;
      this.clientLocation = '';
      this.AssignedSR = null;
      this.Assigneditem = {};
      this.tripCreationDate = '';
      this.tripStartDate = "";
      this.tripEndDate = "";
      this.assignedTo = "";
      this.getTripListing();
      this.selectedcompanyName = {};

    },

    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.getTripListing();
    },
    async getCustomTableEvent(id){
      this.podID = id
      this.reason ="";
      if(id.actionType=="triptag" || id.actionType=="closetag"){
      var obj = this.tableArr.find(item => item.id === id.id);
      if(id.actionType=="triptag"){
        await this.$fire({
          title: `Tms Trip Id: ${obj.tmstripid}`,
          text: "This trip qualifies for Direct to Hub. Do you want to send shipment directly to hub?",
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        }).then((result) => {
          if(result.value == true) {
              this.changeStandToDTH(id)
          }
        }).catch((err)=>{
         console.log(err)
        })
      }
      if(id.actionType=="closetag"){
      await this.$fire({
        title: `Tms Trip Id: ${obj.tmstripid}`,
        text: "Are you sure you want to convert the ongoing DTH trip to standered trip?",
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then((result) => {
        if(result.value == true) {
          this.dthId = id;
          this.showDTHtostandered = true;
        }
      }).catch((err)=>{
       console.log(err)
      })
      }
    }else if(id.actionType=="approved-pickupright" || id.actionType=="pending-pickupright") {
      var obj = this.tableArr.find(item => item.id === id.id);
      let helperlist = []
      let html = "<style> #helpertable{ border-collapse: collapse; width: 100%;} #helpertable td{border:1px solid #ddd;padding:8px}#helpertable tr:nth-child(2n){background-color:#f2f2f2}#helpertable tr:hover{background-color:#ddd} .helpertooltip {position: relative; display: inline-block; font-size: 21px; color: #3085d6;} .helpertooltip .helpertooltiptext {visibility: hidden;width: 320px;background-color: black;color: #fff;text-align: center;border-radius: 6px;padding: 5px 0;position: absolute;z-index: 1; font-size: 14px;} .helpertooltip:hover .helpertooltiptext { visibility: visible; }</style>"
      html= html + `<div> ${obj.username} has requested to extend his trip rights to below user`;
      let tablehtml = ""
      let pendingapproval =0 ;
      let approved = false;
      let showButton = false;
      if (obj.helper) {
        for (const property in obj.helper) {
          tablehtml = tablehtml + `<tr><td style="text-align: right;">`;
          if (obj.helper[property].status == 1 || obj.helper[property].status == 2) {
            tablehtml = tablehtml + `<input type="checkbox" style="position:unset" id="${obj.helper[property].id}" class="${obj.helper[property].id}" />`
            helperlist.push(obj.helper[property].id)
          } else if (obj.helper[property].status == 3) {
            tablehtml = tablehtml + `<input type="checkbox" style="position:unset" disabled />`
          } 
          tablehtml = tablehtml + ` </td><td> ${obj.helper[property].name} (${obj.helper[property].id}) </td><td>`
          if (obj.helper[property].status == 3) {
            tablehtml = tablehtml + `<spna style="color: red;">Rejected</spna>`
          } else if (obj.helper[property].status == 2) {
            tablehtml = tablehtml + `<spna style="color: green;">Approved</spna>`
            approved = true;
          } else if (obj.helper[property].status == 1) {
            tablehtml = tablehtml + `<spna style="color: #ff8d00;">Pending</spna>`
            pendingapproval = 1
            showButton = true;
          }
          tablehtml = tablehtml +`</<td></tr>`;
        }
      }
      if (pendingapproval == 1) {
        html= html + `, Would you like to approve/reject ?  `
      } else {
        html= html + `.  `
      }
      html= html + `<span class="helpertooltip"><i class="fa fa-info-circle" aria-hidden="true"></i><span class="helpertooltiptext">Select SR name and click Aprove/Reject to approve/reject</span> </span></div><br> <table id="helpertable">`;
      html=html+tablehtml;
      html=html + "</table>"
        await this.$fire({
          title: `Tms Trip Id: ${obj.tmstripid}`,
          html: html,
          showCancelButton: showButton || approved,
          showCloseButton: true,
          showConfirmButton: showButton,
          confirmButtonText: 'Approve',
          cancelButtonText: 'Reject',
          confirmButtonAriaLabel: 'Approve',
          cancelButtonAriaLabel: 'Reject',
          cancelButtonColor: '#f64846',
          focusCancel: showButton || approved,
          preConfirm: () => {
          }
        }).then(async (result) => {
          if(result.value) {
            let checkboxChecked = false;
            helperlist.forEach(item => {
              let selected = document.getElementById(`${item}`).checked  
              if (selected) {
                checkboxChecked = true;
                obj.helper[item].status = 2
              }
            })
            if (checkboxChecked) {
              this.approveHelperRequest(obj, 2, []);
            } else {
              await this.$alert("Please select atleast one User to Approve.", "", "error");
              this.getCustomTableEvent(id)
            }
          } else if (result.dismiss == 'cancel') {
            let checkboxChecked = false;
            let approvedUSerId= []
            helperlist.forEach(item => {
              let selected = document.getElementById(`${item}`).checked  
              if (selected) {
                checkboxChecked = true;
                if (obj.helper[item].status == 2) {
                  approvedUSerId.push(obj.helper[item].id)
                }
                obj.helper[item].status = 3
              }
            })
            if (checkboxChecked) {
              this.approveHelperRequest(obj, 3, approvedUSerId);
            } else {
              await this.$alert("Please select atleast one User to Reject.", "", "error");
              this.getCustomTableEvent(id)
            }
          }
        }).catch((err)=>{
         console.log(err)
        })
    }else{
      if(id.actionType== 'edit'){
        this.parentData = {
          tripId: id.id,
          actionType: 'edit'
        }
        this.showCreateTrip = true
        this.TripType = 'created'
      }else{
        this.isLoading = true;
        this.viewTripMgmt = false
        let input = {
          tripId: id.id
        }
        let result = await TripServices.getTripDetails(input);
        this.parenttripfm = {
          firstmile:result.data.data.firstmilearr,
        },
        this.parenttriplm = {
         lastmile: result.data.data.lastmilearr,
        }
        this.pickuprequestid = {
          pickupreq: result.data.data.pickuprequest,
          pickuprequestarr : result.data.data.pickuprequestawb
        }
        this.cargopod = result.data.data.cargopod
        this.tripSheet.username=result.data.data.tripdata.username
        this.tripSheet.usertype=result.data.data.tripdata.usertype
        this.tripSheet.tripID=id.id
        this.tripSheet.tmstripid=result.data.data.tripdata.tmstripid
        this.tripSheet.openkm=result.data.data.tripdata.openkm
        this.tripSheet.vehiclenumber=result.data.data.tripdata.vehiclenumber
        this.tripSheet.isdth=result.data.data.tripdata.isdth
        this.isLoading = false;
        if(result.data.code == 200){
          this.tripDetails = result.data.data.tripdata
          this.awbdetails = result.data.data
          this.mpsFM = result.data.data.fmmps[0]
          this.mpsLM = result.data.data.lmmps[0]
          this.tripDetails.tripstartdate = this.tripDetails.tripstartdate ? Util.displayDateTimeFormat(this.tripDetails.tripstartdate) : this.tripDetails.tripstartdate
          this.tripDetails.tripenddate = this.tripDetails.tripenddate ? Util.displayDateTimeFormat(this.tripDetails.tripenddate) : this.tripDetails.tripenddate
          this.tripStatus = this.tripDetails.tripstatus
          this.closeToolMessage =  this.tripStatus != 'closed' && (this.tripDetails.isdth == 1 && this.tripDetails.hubid == this.defaultHubID && result.data.data.tripdata.motherhubname) ? `This is Direct To Hub Trip. It will be closed at ${result.data.data.tripdata.motherhubname} hub.` : ""
        }
        this.viewTripMgmt = true
        this.parentData = {
          tripId: id.id,
          actionType: 'closetrip'
        }
      }
    }
    },
    closeDTHtostandered(){
      this.reason ="";
      this.showDTHtostandered = false;

    },
    resetFilter(){
      this.$router.replace({'query': null});
      this.tripid = ''
      this.tripStatus = null
      this.AWB = ''
      this.companyName = null
      this.clientLocationitem = {}
      this.clientLocation = ''
      this.AssignedSR =  this.userrole == 'TSP BA Admin' ? this.AssignedSR : null
      this.tripCreationDate = ''
      this.tripStartDate = ''
      this.tripEndDate = ''
      this.MPS = ''
      this.assignedTo = ''
      this.onPageChange(1)
    },
    async DownloadTrips(){
      try {
        this.isLoading = true;
        let inputPayload = {
          "hubid":this.defaultHubID, //for testing use 24
        }
        if(this.tripid){
          inputPayload.tripid = this.tripid;
        }
        if(this.tripStatus){
          inputPayload.tripstatus = this.tripStatus;
        }
        if(this.AWB){
          inputPayload.awb = this.AWB;
        }
        if(this.MPS){
          inputPayload.mps = this.MPS;
        }
        if(this.companyName){
          inputPayload.clientid = this.companyName.id;
        }
        if(this.clientLocation){
          inputPayload.clientlocation = this.clientLocation;
        }
        if(this.AssignedSR){
          inputPayload.sruserid = this.AssignedSR;
        }
        if(this.tripCreationDate[0]){
          inputPayload.tripcreateddate = this.tripCreationDate;
        }
        if(this.tripStartDate){
          inputPayload.tripstartdate = this.tripStartDate;
        }
        if(this.tripEndDate){
          inputPayload.tripenddate = this.tripEndDate;
        }
        if(this.assignedTo){
          inputPayload.assigneduser = this.assignedTo;
        }
        let result = await TripServices.getTripList(inputPayload)
        if(result.data.code == 200){
          let tempdata = result.data.data.rows.map((el)=>{
            el.tripstatus=el.tripstatus=='created'?'Created':el.tripstatus=='start'?'Started':el.tripstatus=='completed'?'Completed':el.tripstatus=='closed'?'Closed':el.tripstatus
            let triptags = '';
            if (el.isdth && el.isdth == 1) {
              triptags = triptags ==''? 'DTH' : `${triptags}, DTH`
            }
            if (el.helper) {
              let PRtag = false
              for (const key in el.helper) {
                if (el.helper.hasOwnProperty(key)) {
                  if(el.helper[key].status == 2) {
                    PRtag = true
                  }
                  
                }
              }
              if(PRtag) {
                triptags = (triptags =='')? 'PR' : `${triptags}, PR`
              }
            }
            return {
              'Trip ID':el.tmstripid,
              'Cargo TripID': el.cargotripid,
              'Trip Status':el.tripstatus,
              'Client Short/ Display Name': '',
              'Assigned To': el.usertype,
              'Assigned BA/ SR': el.username,
              'Trip Created\Date': Util.displayDateOnlyFormat(el.tripcreateddate),
              'Trip Tags' : triptags,
            }
          })
          let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');
          const data = XLSX.utils.json_to_sheet(tempdata);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, data, 'data')
          XLSX.writeFile(wb,dt+'tripData.xlsx');
        }else{
          // this.totalCount = 0
          // this.tableItems = [];
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async changeStandToDTH(id){
      try {
        this.isLoading = true;
        var obj = this.tableArr.find(item => item.id === id.id)
        let input = {
          tripid: obj.id,
          triptag:obj.isdth == 1 ? 2 : 1,
          hubid: this.defaultHubID,
          tmstripid: obj.tmstripid,
          vehiclecapacity: "",
          changereason:this.reason,
          updatedby:this.userName
        }
        let result = await TripServices.convertStanderedtoDTH(input);
        if(result.data.code == 200){
          this.$alert("Updated Successfully", "", "success");
          this.showDTHtostandered = false;
          this.getTripListing();
        } else{
          this.$alert(result.data.message, "", "error");
        }
        this.isLoading = false;

      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    async approveHelperRequest(obj, action, approvedUSerId) {
      try {
        this.isLoading = true;
        let input = {
          tripid: obj.id,
          approvalstatus: action,
          lastmodifiedby: this.userName,
          approveduserid: approvedUSerId,
          helperdata: obj.helper
        }
        let result = await TripServices.approveHelperRequest(input);
        if(result.data.code == 200){
          this.$alert("Updated Successfully", "", "success");
          this.showDTHtostandered = false;
          this.getTripListing();
        } else{
          this.$alert(result.data.message, "", "error");
          this.getTripListing();
        }
        this.isLoading = false;
      } catch (error) {
        console.log(error);
      }
    },

    onSubmit: function() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.changeStandToDTH(this.dthId);
        }
      }).catch(() => {
        console.log('errors exist')
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/TripManagement/TripManagementListing/TripManagementListing.component.js